<template>
  <div class="subpage">
    <div class="page-navbar">
      <div class="page-navbar-wrapper">
        <ul>
          <li
            :data-menuanchor="navbar.anchor"
            :key="i"
            @click="moveToSection(i)"
            v-for="(navbar, i) in this.color.text.pageNavbar"
          >
            <span>{{ navbar.name }}</span>
          </li>
        </ul>
        <div class="scroll-downs">
          <div class="mousey">
            <div class="scroller"></div>
          </div>
        </div>
      </div>
    </div>
    <full-page :options="color.options" id="fullpage" ref="fullpage">
      <div
        class="subpage-header section fp-auto-height-responsive"
        data-anchor="color"
      >
        <div class="section-container">
          <div class="section-wrapper text-right">
            <h2
              class="uppercase header"
              data-aos="text-focus-in"
              data-aos-duration="500"
            >
              Lakiery i akcesoria
            </h2>
          </div>
        </div>
      </div>
      <div
        class="gallery-slider section fp-auto-height-responsive"
        data-anchor="accesory"
      >
        <div class="section-container">
          <div class="section-wrapper">
            <h5
              class="uppercase header-sub"
              data-aos="fade-down"
              data-aos-duration="500"
            >
              {{ this.color.text.equipmentHeaderSub }}
            </h5>
            <h2
              class="uppercase header"
              data-aos="zoom-in"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              {{ this.color.text.equipmentHeader }}
            </h2>
          </div>
          <div class="gallery-nav">
            <i class="fas fa-angle-left" @click="prevGallerySlide"></i>
            <i class="fas fa-angle-right" @click="nextGallerySlide"></i>
          </div>
          <swiper
            :options="color.galleryMainSlider"
            class="swiper slider-flex"
            ref="gallerySlider"
          >
            <swiper-slide
              class="slider-item"
              :key="index"
              v-for="(gallery, index) in this.color.text.gallerySlider"
            >
              <swiper
                :options="color.gallerySlider"
                class="swiper slider-flex gallery"
                data-selector=".swiper-slide:not(.swiper-slide-duplicate)"
                ref="galleryImagesSlider"
              >
                <swiper-slide
                  class="slider-item"
                  :key="i"
                  :data-src="require('@/assets/images/color/' + image.image)"
                  v-for="(image, i) in gallery.images"
                >
                  <div
                    class="background"
                    :style="{
                      backgroundImage:
                        'url(' +
                        require('@/assets/images/color/' + image.image) +
                        ')'
                    }"
                  >
                    <i class="fas fa-image"></i>
                  </div>
                  <div class="text">
                    <p class="description">
                      {{ image.name }}
                    </p>
                  </div>
                </swiper-slide>
              </swiper>
            </swiper-slide>
          </swiper>
          <div class="under-slider">
            <ul
              class="slider-pagination"
              data-aos="zoom-in"
              data-aos-duration="500"
            >
              <li
                :class="
                  i === color.galleryMainSliderActiveIndex
                    ? 'current-slide'
                    : ''
                "
                :key="i"
                @click="goToPage(i)"
                class="text-uppercase"
                v-for="(item, i) in this.color.text.gallerySlider"
              >
                {{ item.header }}
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div
        class="car-slider section fp-auto-height-responsive"
        data-anchor="upholstering"
      >
        <div class="section-container">
          <div class="section-wrapper">
            <h5
              class="uppercase header-sub"
              data-aos="fade-down"
              data-aos-duration="500"
            >
              {{ this.color.text.upholsteringHeaderSub }}
            </h5>
            <h2
              class="uppercase header"
              data-aos="zoom-in"
              data-aos-delay="150"
              data-aos-duration="500"
            >
              {{ this.color.text.upholsteringHeader }}
            </h2>
            <div class="car-slider-item">
              <swiper
                :options="color.carSlider"
                class="swiper slider-flex"
                ref="carSlider"
                @slideChange="updateCarSliderIndex"
              >
                <swiper-slide
                  class="slider-item"
                  :key="index"
                  v-for="(car, index) in this.color.text.carSlider"
                >
                  <img
                    :src="require('@/assets/images/color/' + car.car)"
                    :alt="car.name"
                    data-aos="zoom-in"
                    data-aos-delay="300"
                    data-aos-duration="500"
                  />
                  <p data-aos="text-focus-in" data-aos-duration="500">
                    {{ car.name }}
                  </p>
                </swiper-slide>
              </swiper>
              <div class="car-nav">
                <i class="fas fa-angle-left" @click="prevSlide"></i>
                <i class="fas fa-angle-right" @click="nextSlide"></i>
              </div>
            </div>
            <div
              class="car-dots"
              data-aos="zoom-in"
              data-aos-delay="450"
              data-aos-duration="500"
            >
              <div
                :class="index === color.carSliderIndex ? 'active item' : 'item'"
                :key="index"
                v-for="(item, index) in this.color.text.carSlider"
                :style="{
                  backgroundImage:
                    'url(' + require('@/assets/images/color/' + item.icon) + ')'
                }"
                @click="goToCarSliderPage(index)"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="seats-slider section fp-auto-height-responsive"
        data-anchor="seats"
      >
        <div class="section-container">
          <swiper
            :options="color.seatSlider"
            class="swiper slider-flex"
            ref="seatSlider"
          >
            <swiper-slide
              class="slider-item"
              :key="index"
              v-for="(seat, index) in this.color.text.seatsSlider"
            >
              <div
                class="background"
                :style="{
                  backgroundImage:
                    'url(' +
                    require('@/assets/images/color/' + seat.background) +
                    ')'
                }"
              ></div>
              <div class="desc">
                <p
                  class="text-uppercase"
                  data-aos="text-focus-in"
                  data-aos-duration="500"
                >
                  {{ seat.desc }}
                </p>
              </div>
              <div class="image">
                <img
                  :src="require('@/assets/images/color/' + seat.seat)"
                  :alt="seat.name"
                  data-aos="zoom-in"
                  data-aos-delay="300"
                  data-aos-duration="500"
                />
              </div>
            </swiper-slide>
          </swiper>
          <div class="seats-nav">
            <i class="fas fa-angle-left" @click="prevSeatSlide"></i>
            <i class="fas fa-angle-right" @click="nextSeatSlide"></i>
          </div>
        </div>
      </div>
      <div
        class="footer section fp-auto-height-responsive"
        data-anchor="features"
      >
        <div class="section-container"></div>
        <Footer></Footer>
      </div>
    </full-page>
  </div>
</template>

<script>
import Footer from "@/components/Footer.vue";
import FullPage from "vue-fullpage.js/src/FullPage.vue";
import "swiper/dist/css/swiper.css";

import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "Color",
  components: {
    swiper,
    swiperSlide,
    FullPage,
    Footer
  },
  computed: {
    ...mapGetters({
      color: "color",
      header: "header"
    })
  },
  methods: {
    ...mapMutations({
      changeCarSliderPage: "changeCarSliderPage",
      changeGallerySliderPage: "changeGallerySliderPage"
    }),
    updateHomeHeaderSize() {
      this.header.homeHeaderYSize = document.querySelector(
        ".subpage-header"
      ).offsetHeight;

      setTimeout(() => {
        this.$refs.gallerySlider.swiper.update();
        this.$refs.galleryImagesSlider[
          this.$refs.gallerySlider.swiper.realIndex
        ].swiper.update();
      }, 50);
    },
    moveToSection(index) {
      this.$refs.fullpage.api.moveTo(index + 1);
    },
    prevSlide() {
      this.$refs.carSlider.swiper.slidePrev();
      this.updateCarSliderIndex();
    },
    nextSlide() {
      this.$refs.carSlider.swiper.slideNext();
      this.updateCarSliderIndex();
    },
    prevGallerySlide() {
      this.$refs.galleryImagesSlider[
        this.$refs.gallerySlider.swiper.realIndex
      ].swiper.slidePrev();
    },
    nextGallerySlide() {
      this.$refs.galleryImagesSlider[
        this.$refs.gallerySlider.swiper.realIndex
      ].swiper.slideNext();
    },
    prevSeatSlide() {
      this.$refs.seatSlider.swiper.slidePrev();
      this.updateCarSliderIndex();
    },
    nextSeatSlide() {
      this.$refs.seatSlider.swiper.slideNext();
    },
    goToCarSliderPage(value) {
      this.$refs.carSlider.swiper.slideTo(value);
      this.updateCarSliderIndex();
    },
    updateCarSliderIndex() {
      this.changeCarSliderPage(this.$refs.carSlider.swiper.realIndex);
    },
    goToPage(value) {
      this.$refs.gallerySlider.swiper.slideToLoop(value);
      this.updatePaginationIndex();
    },
    updatePaginationIndex() {
      this.changeGallerySliderPage(this.$refs.gallerySlider.swiper.realIndex);
    }
  },
  mounted() {
    const galleries = document.getElementsByClassName("gallery");
    const body = document.querySelector("body");

    galleries.forEach(e => {
      window.lightGallery(e, {
        selector: e.getAttribute("data-selector"),
        download: false,
        autoplay: false,
        videoMaxWidth: "1920px"
      });
    });

    body.classList.add("no-overflow");

    this.$refs.carSlider.swiper.update();

    this.updateHomeHeaderSize();
    window.addEventListener("resize", this.updateHomeHeaderSize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateHomeHeaderSize);
  }
};
</script>

<style scoped lang="scss">
@import "src/styles/mixins";
@import "src/styles/page-navbar";
@import "src/styles/footer-subpage";
@import "src/styles/section-background";

.subpage-header {
  @include set-background(no-repeat, center center, cover);
  background-image: url("../assets/images/color/header-background.jpg");
  padding: var(--page-offset);

  .section-container {
    @include display-flex(flex, wrap);
    height: 100%;
    padding: var(--page-offset);
    align-content: center;
    justify-content: flex-end;

    .section-wrapper {
      width: 50%;

      @media screen and (max-width: $screen-md) {
        width: 75%;
      }

      @media screen and (max-width: $screen-sm) {
        width: 100%;
      }

      .header {
        span {
          color: $mmc-blue;
        }
      }
    }
  }
}

.gallery-slider {
  overflow: hidden;

  .section-container {
    @include display-flex(flex, wrap);
    height: 100%;

    @media screen and (max-height: $screen-height-es) {
      height: auto;
    }

    @media screen and (max-width: $screen-sm) {
      height: auto;
    }

    .section-wrapper {
      @include size-flex(100%);
      padding: var(--page-offset) calc(2 * var(--page-offset)) 0;

      @media screen and (max-height: $screen-height-es) {
        padding-bottom: 10rem;
      }

      @media screen and (max-width: $screen-sm) {
        padding-bottom: 0;
      }

      .header-sub {
        color: $mmc-blue;

        &.second {
          color: $black;
        }
      }

      .header {
        color: $black;
      }
    }

    .gallery-nav {
      i {
        @include font-size-color(3rem, $mmc-red);
        @include set-position(
          absolute,
          50%,
          auto,
          auto,
          calc(1.1 * var(--page-offset))
        );
        z-index: 2;
        cursor: pointer;
        transform: translateY(-50%);

        &:last-of-type {
          left: auto;
          right: calc(1.25 * var(--page-offset));
        }

        @media screen and (max-width: $screen-sm) {
        }
      }
    }

    .swiper-container {
      overflow: visible;
    }

    .swiper {
      @include display-flex(flex, wrap);
      @include size-flex(100%);

      .slider-item {
        height: 50vh;

        @media screen and (max-height: $screen-height-es) {
          height: auto;
        }

        @media screen and (max-width: $screen-sm) {
          height: auto;
        }

        .slider-item {
          &.swiper-slide-active {
            .text {
              opacity: 1;
            }
          }

          .text {
            transition: opacity 0.3s ease-in-out;
            opacity: 0;
            z-index: 1;
            width: 100%;
            text-align: center;

            .description {
              color: $slider-description;
              margin: 1rem 0 0 !important;
              line-height: 1;

              @media screen and (max-width: $screen-lg) {
                margin: 1rem 0;
              }
            }
          }
        }

        .background {
          @include set-size(100%, calc(100% - 50px));
          @include set-background(no-repeat, center center, cover);
          @include image-hover();

          @media screen and (max-width: $screen-lg) {
            @include set-size(100%, calc(100% - 65px));
          }

          @media screen and (max-width: $screen-md) and (orientation: landscape) {
            &::after {
              padding-top: 50%;
            }
          }

          @media screen and (max-width: $screen-sm) {
            &::after {
              padding-top: 50%;
            }
          }
        }
      }
    }
  }

  .under-slider {
    @include display-flex(flex, wrap);
    @include size-flex(100%);
    padding: var(--page-offset) calc(2 * var(--page-offset))
      calc(var(--page-offset) / 2);
    align-self: flex-start;

    .slider-pagination {
      @include display-flex(flex, wrap);
      @include size-flex(100%);
      @include margin-padding(0, 0);
      list-style: none;
      border-bottom: 2px solid $slider-description;

      @media screen and (max-width: $screen-sm) {
        @include size-flex(100%);
        border-bottom: none;
      }

      li {
        @include font-size-color(1rem, $slider-description);
        position: relative;
        flex: 1 0 auto;
        align-self: flex-end;
        padding-bottom: 1rem;
        cursor: pointer;
        font-weight: 500;
        line-height: 1;
        padding-right: 1rem;

        @media screen and (max-width: $screen-xxl) {
          font-size: 0.9rem;
        }

        @media screen and (max-width: 1300px) {
          font-size: 0.8rem;
        }

        @media screen and (max-width: $screen-lg) {
          flex: 1 0 20%;
        }

        @media screen and (max-width: $screen-sm) {
          padding-top: 1rem;
          flex: 1 0 100%;
        }

        &::after {
          @include set-position(absolute, auto, auto, -2px, 0);
          @include set-size(100%, 4px);
          content: "";
          background-color: transparent;
          transition: background-color 0.3s ease-in-out;
        }

        &.current-slide {
          color: $slider-header;

          &::after {
            background-color: $mmc-red;
          }
        }
      }
    }
  }
}

.car-slider {
  .section-container {
    @include display-flex(flex, wrap);
    padding: var(--page-offset) calc(2 * var(--page-offset));
    height: 100%;
    align-content: center;
  }

  .section-wrapper {
    @include size-flex(100%);
    box-sizing: border-box;
  }

  .header-sub {
    color: $mmc-blue;
  }

  .header {
    color: $black;
  }

  .car-slider-item {
    @include size-flex(100%);
    position: relative;

    .slider-item {
      img {
        max-width: 100%;
        margin: 0 auto;
      }

      p {
        @include size-flex(100%);
        @include font-size-color(1.25rem, $black);
        font-weight: 500;
        text-transform: uppercase;
        text-align: center;
      }
    }
  }

  .car-nav {
    i {
      @include font-size-color(3rem, $mmc-red);
      @include set-position(absolute, 50%, auto, auto, -0.75rem);
      z-index: 2;
      cursor: pointer;
      transform: translateY(-50%);

      &:last-of-type {
        left: auto;
        right: -0.75rem;
      }

      @media screen and (max-width: $screen-sm) {
        display: none;
      }
    }
  }

  .car-dots {
    text-align: center;

    @media screen and (max-width: $screen-es) {
      @include display-flex(flex, wrap);
      justify-content: center;
    }

    .item {
      @include set-background(no-repeat, center center, cover);
      @include set-size(3rem, 3rem);
      display: inline-block;
      margin-right: 0.5rem;
      border: 1px solid $slider-description;
      cursor: pointer;
      box-shadow: 0 0 5px 1px transparent;
      transition: all 0.3s ease-in-out;

      @media screen and (max-width: $screen-es) {
        @include set-size(auto, auto);
        @include size-flex(calc(20% - 0.75rem));
        display: block;
        margin: 0 1rem 1rem 0;

        &:nth-of-type(4n + 4) {
          margin-right: 0;
        }

        &::after {
          content: "";
          display: block;
          padding-bottom: 100%;
        }
      }

      &:last-of-type {
        margin-right: 0;
      }

      &.active {
        border-color: $mmc-red;
        box-shadow: 0 0 5px 1px $mmc-red;
      }
    }
  }
}

.seats-slider {
  .section-container {
    height: 100%;
  }

  .slider-item {
    @include display-flex(flex, wrap);
    height: 100vh;

    @media screen and (max-width: $screen-es) {
      height: auto;
    }

    .background {
      @include set-position(absolute, 0, 0, var(--page-offset), 0);
      @include set-background(no-repeat, center center, cover);
    }

    .desc {
      @include size-flex(50%);
      text-align: right;
      box-sizing: border-box;
      align-self: center;
      padding: var(--page-offset);

      @media screen and (max-width: $screen-es) {
        @include size-flex(100%);
        text-align: center;
      }

      p {
        @include font-size-weight(1.25rem, 500);
        margin: 0;
      }
    }

    .image {
      @include size-flex(50%);
      text-align: left;
      box-sizing: border-box;
      align-self: flex-end;
      padding: calc(var(--page-offset) / 2);

      @media screen and (max-width: $screen-es) {
        @include size-flex(100%);
        text-align: center;
      }

      img {
        @include set-max-size(100%, 60rem);

        @media screen and (max-height: $screen-height-lg) {
          max-height: 50rem;
        }

        @media screen and (max-height: $screen-height-sm) {
          max-height: 40rem;
        }

        @media screen and (max-height: $screen-height-es) {
          max-height: 30rem;
        }

        @media screen and (max-width: $screen-es) {
          max-height: 20rem;
        }
      }
    }
  }

  .seats-nav {
    i {
      @include font-size-color(3rem, #ffffff /*$mmc-red*/);
      @include set-position(
        absolute,
        70%,
        auto,
        auto,
        calc(1.25 * var(--page-offset))
      );
      z-index: 2;
      cursor: pointer;
      transform: translateY(-50%);

      &:last-of-type {
        left: auto;
        right: calc(1.25 * var(--page-offset));
      }

      @media screen and (max-width: $screen-sm) {
        display: none;
      }
    }
  }
}

.footer {
  .section-container {
    @include set-background(no-repeat, center center, cover);
    background-image: url("../assets/images/color/footer-background.jpg");
  }
}
</style>
